module.exports = __webpack_public_path__ + "static/media/zocalo17.2551860b.jpg";